import React, {FC} from 'react'

export const StickyNotesIcon: FC = () => (
    <svg className='canvas-toolbar__icon' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'>
        <path d='M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z'/>
        <polyline points='14 2 14 8 20 8'/>
        <line x1='8' y1='13' x2='16' y2='13'/>
        <line x1='8' y1='17' x2='16' y2='17'/>
        <polyline points='10 9 9 9 8 9'/>
    </svg>
)
